export const storageConstants = {
  SKETCH_INNER_CONFIGS: 'sketchInnerConfigs',
  SKETCH_OUTER_CONFIGS: 'sketchOuterConfigs',
  CHAIN_TX_COUNT_LIST: 'chainTransactionCountList',
  CHAINID_AND_ICON_LIST: 'chainIdAndIconList',
};
